module.exports = __webpack_public_path__ + "_assets/img/clock.64e162bd.svg";